module.exports = __webpack_public_path__ + "static/img/78-1.a39cb8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/78-1.jpg
// module id = 0Oif
// module chunks = 0